module.exports = __webpack_public_path__ + "img/UTFHNH.15e73a12.png";